exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".applet-menu-content[data-v-45fba9e6]{width:100%;padding-top:1.066667rem;background-size:auto 50%;background-position:top;background-repeat:no-repeat;font-size:.346667rem;line-height:.586667rem;text-align:center;margin-top:.533333rem;position:relative}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-45fba9e6","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AppletIconMenu.vue
// module id = 440
// module chunks = 0